module.exports = __webpack_public_path__ + "img/Lupin.453de39e.svg";